import React from 'react';
import Main from './Main';
import Introduce from './Introduce';
import Works from './Works';
import Footer from './Footer';

import '../css/index.css';

function MainContainer() {

    const bg = {
        backgroundImage:`url('${process.env.PUBLIC_URL}/images/rusty.jpg')`,
    };

    const smallTxt = {
        fontSize:'0.5rem',
    };
    
    return (
        <>
            <main>
                <Main bg={bg}/>
                <Introduce fontSize={smallTxt}/>
                <Works />
            </main>
            <Footer bg={bg}/>
        </>
    );
}

export default MainContainer;